import { Map as MapLibreMap, Marker, NavigationControl } from "maplibre-gl";
import ElementController from "../base-controllers/ElementController.js";
import { loadMapStyle } from "./DeliveryPlanningMap.js";
/** A single place, using the same map provider/style as delivery planning. */
class PlaceMap extends ElementController {
    constructor() {
        super(...arguments);
        this.map = null;
        this.observer = null;
        this.resizeFrame = null;
        this.abort = null;
        this.attempted = false;
    }
    init() {
        // A dialog may be hidden when controllers initialize. Wait for a real size,
        // and resize again when it opens or its layout changes.
        this.observer = new ResizeObserver(() => {
            // Map/error rendering can resize the observed section. Defer those writes
            // out of ResizeObserver delivery to avoid a resize feedback loop.
            if (this.resizeFrame !== null)
                return;
            this.resizeFrame = requestAnimationFrame(() => {
                this.resizeFrame = null;
                if (!this.root.getBoundingClientRect().width)
                    return;
                if (this.map)
                    this.map.resize();
                else
                    void this.createMap();
            });
        });
        this.observer.observe(this.root);
    }
    async createMap() {
        if (this.attempted)
            return;
        this.attempted = true;
        const latitude = Number(this.root.dataset.latitude);
        const longitude = Number(this.root.dataset.longitude);
        if (!this.root.dataset.latitude || !this.root.dataset.longitude ||
            !Number.isFinite(latitude) || !Number.isFinite(longitude) ||
            Math.abs(latitude) > 90 || Math.abs(longitude) > 180)
            return;
        const container = this.root.querySelector("[data-place-map-canvas]");
        if (!container)
            return;
        this.abort = new AbortController();
        const { signal } = this.abort;
        try {
            const style = await loadMapStyle(signal);
            if (signal.aborted || !this.root.isConnected)
                return;
            this.map = new MapLibreMap({
                container, style, center: [longitude, latitude], zoom: 14,
                attributionControl: { compact: true }, cooperativeGestures: true,
            });
            this.map.scrollZoom.disable();
            this.map.addControl(new NavigationControl({ showCompass: false }), "top-right");
            new Marker().setLngLat([longitude, latitude]).addTo(this.map);
            this.map.once("load", () => this.map?.resize());
            this.map.on("error", () => this.showError());
        }
        catch {
            if (!signal.aborted)
                this.showError();
        }
    }
    showError() {
        const error = this.root.querySelector("[data-place-map-error]");
        if (error)
            error.hidden = false;
    }
    destroy() {
        this.observer?.disconnect();
        if (this.resizeFrame !== null)
            cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = null;
        this.abort?.abort();
        this.map?.remove();
        this.map = null;
        super.destroy();
    }
}
PlaceMap.id = "PlaceMap";
export default PlaceMap;
//# sourceMappingURL=PlaceMap.js.map